import { Injectable } from '@angular/core';
import { Action } from '../model/action';
import { TimeSlot } from '../model/time-slot';
import { Schedule } from '../../appointment/model/appointment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';
@Injectable()
export class TimeslotMasterService {
    http:HttpClientService;
    cookie : CookiesService;
    objAction : Action;
    data : TimeSlot;
    constructor(http : HttpClientService, cook : CookiesService) {
       this.http = http;
       this.cookie = cook;
       this.objAction  = new Action(this.http,  this.cookie);
    }
    saveTimeSlot() : Observable<TimeSlot> {   
       this.objAction.header = null;
       this.objAction.data = this.data;
       this.objAction.path = 'api/Slots/CreateSlots';
       return this.objAction.save();
    }
    getTimeSlots(id: number ) :   Observable<TimeSlot[]> {
       this.objAction.path = 'api/Slots/GetSlots?DoctorId='+id
      return this.objAction.get();
    }

    saveSchedule(schedule: Schedule[]) {
      this.objAction.header = null;
       this.objAction.data = schedule;
       this.objAction.path = 'api/Slots/SaveScheduleSlots';
       return this.objAction.save();
    }

    getSceduleTimeSlots(id: number ) :   Observable<Schedule[]> {
      this.objAction.path = 'api/Slots/GetScheduleSlots?DoctorId='+id
     return this.objAction.get();
   }

    updateTimeSlot() : Observable<TimeSlot> {   
      this.objAction.header = null;
      this.objAction.data = this.data;
      this.objAction.path = 'api/Slots/UpdateSlots'
      return this.objAction.update();
    }
    deleteTimeSlot(org : TimeSlot) : Observable<TimeSlot> {
      this.objAction.header = null;
      this.objAction.data = this.data;
      this.objAction.path = 'api/Slots/DeleteSlots?strSlotId=' + org.SlotId; 
      return this.objAction.delete();
   }

}



// WEBPACK FOOTER //
// ./src/app/section/master/services/timeslot-master.service.ts